export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"Paris Institute for Advanced Study"},{"name":"msapplication-TileColor","content":"#FFFFFF"},{"name":"theme-color","content":"#2196f3"},{"property":"author","content":"PARIS IAS"},{"property":"og:site_name"},{"property":"og:locale","content":"en_US"},{"property":"og:type","content":"website"},{"property":"twitter:site"},{"property":"twitter:domain"},{"property":"twitter:creator","content":"PARIS IAS"},{"property":"twitter:card","content":"summary"},{"property":"twitter:image:src","content":"/images/icon.png"},{"property":"og:url"},{"property":"og:title","content":"PARIS IAS"},{"property":"og:description","content":"Paris Institute for Advanced Study"},{"name":"twitter:site"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":{"light":"/logo.png","dark":"/logo_white.png"}},{"property":"og:image","content":{"light":"/logo.png","dark":"/logo_white.png"}},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"}],"link":[],"style":[],"script":[],"noscript":[],"title":"PARIS IAS"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true